import { apiClient } from "@/lib/api-client";

export type DataPerBulan = {
  jabatan_fungsional: string;
  jabatan_struktural: string;
  golongan: string;
  kode_unit: string;
  grade_struktural: number;
  grade_fungsional: number;
  nilai_struktural: number;
  nilai_fungsional: number;
  id_status_sekarang: number;
  id_status_pegawai: number;
  status_sekarang?: string;
  status_pegawai?: string;
  total_poin: number;
  rupiah_bersih_30: number | null;
  rupiah_serdos: string;
  validator_details?: {
    level: string;
    is_valid_taken: boolean;
    validator_name: string;
  }[];
};

export type DosenRemun = {
  niu: string;
  nip?: string;
  NIP?: string;
  nama: string;
  tahun: number;
  semester: number;
  last_generated_at: string;
  data_per_bulan: Record<string, DataPerBulan>;
  unit?: {
    fakultas: string;
    jurusan: string;
    prodi: string;
  };
  Unit?: {
    Fakultas: string;
    Prodi: string;
  };
};

export type DosenRemunResponse = {
  datas: DosenRemun[];
  is_next: boolean;
  status: string;
  pagination?: {
    total: number;
    pages: number;
  };
};

export const fetchDosenRemun = async ({
  queryKey,
}: any): Promise<DosenRemunResponse> => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const [_key, filters] = queryKey;

  const params = new URLSearchParams({
    page: (filters?.page || 1).toString(),
    limit: (filters?.limit || 10).toString(),
    ...(filters?.year && { year: filters.year.toString() }),
    ...(filters?.semester && { semester: filters.semester.toString() }),
    ...(filters?.periodeID && { periodeID: filters.periodeID.toString() }),
    ...(filters?.search && { search: filters.search }),
    ...(filters?.id_status_pegawai && {
      id_status_pegawai: filters.id_status_pegawai.toString(),
    }),
    ...(filters?.id_status_sekarang && {
      id_status_sekarang: filters.id_status_sekarang.toString(),
    }),
    ...(filters?.fkt_kode && { fkt_kode: filters.fkt_kode.toString() }),
    ...(filters?.prd_kode && { prd_kode: filters.prd_kode.toString() }),
    ...(filters?.valid_status && { valid_status: filters.valid_status }),
    ...(filters?.nius && { nius: filters.nius.toString() }),
  });

  return apiClient<DosenRemunResponse>(
    `${baseUrl}/api/v1/dosen-remun?${params.toString()}`,
    {
      headers: {
        Accept: "application/json",
      },
    },
  );
};
